import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import ActionModalHeader, { DemoNote, customerName } from "./ActionModalHeader";

// STATIC DESIGN — extend plan validity free of charge (reads user_plan_end_date)
const OPTIONS = [7, 14, 30, 90];

interface ExtendValidityModalProps { show: boolean; onHide: () => void; user: any }

const ExtendValidityModal = ({ show, onHide, user }: ExtendValidityModalProps) => {
  const [days, setDays] = useState(7);
  useEffect(() => { if (show) setDays(7); }, [show]);

  const end = user?.user_plan_end_date ? moment(user.user_plan_end_date) : null;
  // extending an expired plan starts from today
  const base = end && end.isAfter(moment()) ? end.clone() : moment();
  const newEnd = base.add(days, "days");

  const extend = () => {
    toast.info(`Validity extended by ${days} days to ${newEnd.format("DD MMM YYYY")} · demo only, not saved`);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="cx">
      <ActionModalHeader icon="ri-time-line" title="Extend validity" subtitle={`${customerName(user)} · ${user?.user_plan_name || "No plan"}`} onClose={onHide} />
      <div style={{ padding: "14px 20px" }}>
        <label className="cx-label">Extend by</label>
        <div className="cx-seg">
          {OPTIONS.map(d => <button type="button" key={d} className={days === d ? "on" : ""} onClick={() => setDays(d)}>{d} days</button>)}
        </div>
        <div className="cx-kv" style={{ marginTop: 14 }}>
          <div><small>Current end date</small><b>{end ? end.format("DD MMM YYYY") : "—"}{end && end.isBefore(moment(), "day") && <span className="down fs12"> · expired</span>}</b></div>
          <div><small>New end date</small><b className="up">{newEnd.format("DD MMM YYYY")}</b></div>
        </div>
        <p className="cx-help">The plan validity is extended without charging the customer.</p>
        <DemoNote />
      </div>
      <div style={{ padding: "0 20px 18px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button type="button" className="cx-btn cx-btn-light" onClick={onHide}>Cancel</button>
        <button type="button" className="cx-btn cx-btn-primary" onClick={extend}>Extend</button>
      </div>
    </Modal>
  );
};

export default ExtendValidityModal;
